import { Button, HFlow, Icon, Modal, ModalBody, ModalFooter, ModalHeader, Tooltip, VFlow } from 'bold-ui'
import { alert } from 'components/alert'
import { Form, SubmitButton, TextField } from 'components/form'
import { FormApi } from 'final-form'
import { useAlterarTipoServicoMutation } from 'graphql/hooks.generated'
import { TipoServicoUpdateInput } from 'graphql/types.generated'
import { useMemo, useState } from 'react'
import { FormRenderProps } from 'react-final-form'
import { createValidator, maxLength, minLength, required } from 'util/validation'

import { TipoServicoItem } from '../TipoServicoTable'

export interface TipoServicoEditComponentProps {
  tipoServico: TipoServicoItem
  onEdit(): void
}

const validate = createValidator<TipoServicoUpdateInput>({
  nome: [required, minLength(3), maxLength(30)],
})

export function TipoServicoEditComponent(props: Readonly<TipoServicoEditComponentProps>) {
  const { tipoServico, onEdit } = props

  const [open, setOpen] = useState(false)

  const [alterarTipoServico] = useAlterarTipoServicoMutation()

  const renderForm = (formProps: FormRenderProps) => {
    return (
      <Modal open={open} onClose={() => setOpen(false)} size='small'>
        <ModalHeader title='Editar tipo de serviço' />
        <ModalBody>
          <VFlow vSpacing={2}>
            <TextField name='nome' label='Nome do tipo de serviço' required />
          </VFlow>
        </ModalBody>
        <ModalFooter>
          <HFlow justifyContent='flex-end'>
            <Button onClick={handleCancel(formProps)}>Cancelar</Button>
            <SubmitButton kind='primary' handleSubmit={formProps.handleSubmit}>
              Salvar
            </SubmitButton>
          </HFlow>
        </ModalFooter>
      </Modal>
    )
  }

  const handleCancel = (formProps: FormRenderProps) => () => {
    setTimeout(formProps.form.reset)
    setOpen(false)
  }

  const handleSubmit = (values: TipoServicoUpdateInput, formApi: FormApi) => {
    return alterarTipoServico({ variables: { input: values } }).then(() => {
      alert('success', `Tipo de serviço ${values.nome.toUpperCase()} salvo com sucesso.`)
      setTimeout(formApi.reset)
      setOpen(false)
      onEdit()
    })
  }

  const initialValues = useMemo(() => ({ id: tipoServico.id, nome: tipoServico.nome.toUpperCase() }), [
    tipoServico.id,
    tipoServico.nome,
  ])

  return (
    <>
      <Tooltip text='Editar'>
        <Button size='small' skin='ghost' onClick={() => setOpen(true)}>
          <Icon icon='penOutline' />
        </Button>
      </Tooltip>
      <Form render={renderForm} onSubmit={handleSubmit} initialValues={initialValues} validate={validate} />
    </>
  )
}
